import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Box, Container, Typography } from '@mui/material'
import { COLOR_PRIMARY, NAVBAR_BG, DARK_800 } from '../theme'
import { buildCoreUrl, quicksetup } from '../common/common'
import { FancyGoldButton } from '../components/FancyGoldButton'

const REDIRECT_SECONDS = 10

export default function RegisterComplete() {
    const [countdown, setCountdown] = useState(REDIRECT_SECONDS)

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(interval)
                    window.location.href = buildCoreUrl(quicksetup)
                }
                return prev - 1
            })
        }, 1000)
        return () => clearInterval(interval)
    }, [])

    return (
        <Box sx={{ minHeight: '80vh', bgcolor: '#f7f8fa', display: 'flex', alignItems: 'center' }}>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Container maxWidth="sm">
                <Box sx={{
                    bgcolor: '#fff',
                    borderRadius: 3,
                    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                    overflow: 'hidden',
                }}>
                    {/* Header bar */}
                    <Box sx={{
                        background: `linear-gradient(135deg, ${NAVBAR_BG} 0%, ${DARK_800} 100%)`,
                        px: 4, py: 3, textAlign: 'center',
                    }}>
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', letterSpacing: '0.12em', textTransform: 'uppercase', fontSize: '11px' }}>
                            Contract Finder Pro
                        </Typography>
                        <Typography variant="h5" fontWeight={700} sx={{ color: '#fff', mt: 0.5 }}>
                            Registration Complete
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.65)', mt: 0.75 }}>
                            We'll now guide you through setting up your account
                        </Typography>
                    </Box>

                    {/* Animated checkmark */}
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Box
                            component="svg"
                            className="checkmark"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                            sx={{ width: 80, height: 80 }}
                        >
                            <style>{`
                                .checkmark__circle {
                                    stroke-dasharray: 166;
                                    stroke-dashoffset: 166;
                                    stroke-width: 2;
                                    stroke: ${COLOR_PRIMARY};
                                    animation: stroke 0.6s cubic-bezier(0.65,0,0.45,1) forwards;
                                }
                                .checkmark__check {
                                    transform-origin: 50% 50%;
                                    stroke-dasharray: 48;
                                    stroke-dashoffset: 48;
                                    stroke: ${COLOR_PRIMARY};
                                    stroke-width: 3;
                                    animation: stroke 0.3s cubic-bezier(0.65,0,0.45,1) 0.5s forwards;
                                }
                                @keyframes stroke {
                                    100% { stroke-dashoffset: 0; }
                                }
                            `}</style>
                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </Box>
                    </Box>

                    {/* Body */}
                    <Box sx={{ px: 4, pb: 4, textAlign: 'center' }}>
                        <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
                            Welcome aboard!
                        </Typography>
                        <Typography color="text.secondary" sx={{ fontSize: '14px', mb: 3, lineHeight: 1.7 }}>
                            Your account has been created. Click <strong>Setup Now</strong> to add your CPV codes and keywords
                            so we can start sending you relevant tender alerts every morning.
                        </Typography>

                        <FancyGoldButton
                            onClick={() => { window.location.href = buildCoreUrl(quicksetup) }}
                            width={180}
                        >
                            Setup Now
                        </FancyGoldButton>

                        <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 2.5 }}>
                            Redirecting automatically in {countdown} second{countdown !== 1 ? 's' : ''}…
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}
